;(function () {
  'use strict'

  angular
    .module('contrast.applications')
    .controller('ApplicationsCtrl', ApplicationsCtrl)

  function ApplicationsCtrl(
    $scope,
    $filter,
    $timeout,
    $routeSegment,
    $routeParams,
    $rootScope,
    $q,
    $translate,
    dialogs,
    permissions,
    logger,
    PromiseService,
    LoadFilterService,
    ErrorService,
    ApplicationService,
    LicenseService,
    UserService,
    AdvancedFiltersService,
    LoadFilterRouteService,
    LanguagesService,
    ATTACK_STATUS,
    confirmModal,
    ServiceUtils,
    ApplicationFactory,
    FeaturesService,
    APP_IMPORTANCE_RANKING,
    SUBFILTERS,
    QUICK_FILTERS,
    SERVER_ENVIRONMENT,
    APPLICATION_LICENSES,
    AGENT_FEATURE,
    onboardingTutorialConstants
  ) {
    'ngInject'

    // Minimum amount of apps to avoid sending footer to bottom
    var minAppsForNormalFooter = 10

    var _includeMerged,
      _lastSearch,
      _lastShortSearch,
      _lastShortSearchLoading,
      _subfilterIds,
      _selectedSubFilters,
      _requestMapping,
      _lastSubfilterSearches,
      _shortApplications,
      _searchKeywords,
      _deregisterAppReloadListener,
      _scoreRequests,
      _defaultQuickFilter

    function init() {
      if (UserService.isFreemiumOrganization()) {
        _defaultQuickFilter = {
          name: 'All',
          filterType: 'ALL',
          count: '?'
        }
      } else {
        _defaultQuickFilter = {
          name: 'Licensed',
          filterType: 'LICENSED',
          count: '?'
        }
      }

      _initDefaults()
      $scope.$watch('includeArchived', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          loadSubfilters()
        }
      })
      if (!_deregisterAppReloadListener) {
        _deregisterAppReloadListener = $scope.$on(
          'application.reload',
          function () {
            return refreshApplications()
          }
        )
      }
      $scope.$on('$destroy', _destroy)
      $scope.model.busyPromise = getLicenses().then(loadFilters).then(newSearch)
    }

    function _initDefaults() {
      _includeMerged = true
      _lastSearch = {}
      _lastShortSearch = {}
      _lastShortSearchLoading = false
      _subfilterIds = SUBFILTERS.APPS.ORG.LIST
      _selectedSubFilters =
        AdvancedFiltersService.generateSelectedConfig(_subfilterIds)
      _requestMapping = SUBFILTERS.APPS.ORG.REQUEST_MAPPING
      _lastSubfilterSearches = {}
      _shortApplications = []
      _searchKeywords = ''
      _scoreRequests = {}

      angular.extend($scope, AdvancedFiltersService.getSubfilterLimitConfig())

      angular.extend($scope, {
        applicationsLoaded: false,
        selectedApplications: [],
        licenses: {},

        applications: [],
        applicationScores: {},
        count: 0,

        model: {
          includeArchived: angular.isDefined($routeParams.includeArchived),
          includeChildren: false,
          selectAllCheckbox: false,
          searchKeywords: searchKeywords,
          busy: true,
          uiGridEnabled: $routeSegment.name === 'applicationsUiGrid'
        },

        tutorial: UserService.createOnboardingTutorialItem(
          onboardingTutorialConstants.TUTORIAL_TYPE.APPLICATIONS
        ),

        numPerLoad: 10,

        attack_status: ATTACK_STATUS,
        importances: APP_IMPORTANCE_RANKING,

        order: 'appName',

        filtersVisible: false,
        tagsfilters: {},

        modulesLimit: 5,

        quickFilters: [],
        selectedQuickFilter: _defaultQuickFilter,

        protectionCoverageKnob: {
          displayInput: false,
          animate: {
            enabled: true,
            duration: 500,
            ease: 'linear'
          },
          readOnly: true,
          trackWidth: 6,
          barWidth: 6,
          size: 50
        },
        selectSubfilter: AdvancedFiltersService.selectSubfilter(
          _selectedSubFilters,
          subFilterSelectCallback
        ),
        hasAssessLicenses: hasAssessLicenses,
        newSearch: newSearch
      })

      determineQuickFilter()
    }

    function determineQuickFilter() {
      if (
        angular.isDefined($routeParams.quickfilter) &&
        isValidQuickFilter($routeParams.quickfilter)
      ) {
        $scope.selectedQuickFilter = {
          name: '?',
          filterType: $routeParams.quickfilter.toUpperCase(),
          count: '?'
        }
      }
    }

    function isValidQuickFilter(str) {
      return Object.keys(QUICK_FILTERS.APPS).find(function (key) {
        return key.toLowerCase() === str.toLowerCase()
      })
    }

    angular.extend($scope, {
      loadApplicationsByScroll: loadApplicationsByScroll,

      quickFilterSelect: quickFilterSelect,

      setOrder: setOrder,
      onSelectAll: onSelectAll,
      onSingleSelectAll: onSingleSelectAll,
      refreshApplications: refreshApplications,
      selectAll: selectAll,
      deselectAll: deselectAll,
      toggleSelection: toggleSelection,
      enableAction: enableAction,

      canApplyLicense: canApplyLicense,
      launchBatchDialog: launchBatchDialog,
      launchSingleDialog: launchSingleDialog,
      launchDialog: launchDialog,
      areAllArchived: areAllArchived,
      areAllUnarchived: areAllUnarchived,
      updateImportanceLevel: updateImportanceLevel,
      openPopover: openPopover,
      moveToCritical: moveToCritical,
      onArchivedChange: onArchivedChange,
      onIncludeChildren: onIncludeChildren,

      toggleFilters: toggleFilters,
      filtersSet: filtersSet,
      clearFilters: clearFilters,

      getFiltersSelected: getFiltersSelected,

      tagApplications: tagApplications,
      tagSelectedApplications: tagSelectedApplications,
      showChildModule: showChildModule,
      onAppServersClick: onAppServersClick,
      onAppAttackClick: LoadFilterRouteService.goToAttackEventsFilteredByApp,

      isAssessSupported: isAssessSupported,
      isNodeApp: isNodeApp,

      isBusy: isBusy,
      isSampleApplication: isSampleApplication,

      loadSubfilterOptions: loadSubfilterOptions,
      isProxy: isProxy,

      getAgentFeatures: getAgentFeatures,
      getApplicationLanguageDisplayValue: getApplicationLanguageDisplayValue
    })

    function getApplicationLanguageDisplayValue(applicationLanguage) {
      return LanguagesService.getLanguage(applicationLanguage).display
    }

    function getAgentFeatures() {
      return FeaturesService.getAll()
    }

    function isBusy() {
      return $scope.model.busy
    }

    function _destroy() {
      _deregisterAppReloadListener()
      $rootScope.$broadcast('changeFooterBottom', { shouldSendToBottom: false })
    }

    function subFilterSelectCallback() {
      return ($scope.model.busyPromise =
        loadSubfilters().then(refreshApplications))
    }

    function _buildLoadAppsExpandString() {
      var expand = 'license,trace_breakdown,compliance_policy,metadata'
      if (permissions.isRASPEnabled()) {
        expand += ',production_protected'
      }
      if ($scope.model.includeChildren) {
        expand += ',modules'
      }
      return expand
    }

    function loadApplications(limit, offset) {
      if (_lastSearch) {
        PromiseService.cancelPromise(_lastSearch)
      }

      $scope.model.busy = true

      var filters = {
        limit: limit,
        offset: offset,
        expand: _buildLoadAppsExpandString(),
        sort: $scope.order,
        includeArchived: $scope.model.includeArchived,
        filterText: $scope.model.searchKeywords(),
        includeMerged: _includeMerged,
        quickFilter: $scope.selectedQuickFilter.filterType
      }

      angular.extend(
        filters,
        AdvancedFiltersService.transformSelectedSubfilters(
          _selectedSubFilters,
          _requestMapping
        )
      )

      _lastSearch = ApplicationFactory.getApplicationsByFilter(filters)

      return _lastSearch
        .then(function (response) {
          var apps = response.data.applications,
            app,
            roles

          $scope.count = response.data.count

          for (var i = 0; i < apps.length; i++) {
            app = apps[i]
            roles = app.roles

            app.isProtectLanguageSupported =
              FeaturesService.isAgentFeatureEnabled(
                AGENT_FEATURE.PROTECTION,
                app.language,
                true
              )

            app.isAssessLanguageSupported =
              FeaturesService.isAgentFeatureEnabled(
                AGENT_FEATURE.ASSESS,
                app.language,
                true
              )

            getScore(app.app_id)

            permissions.updateAppPermissions(app.app_id, roles)

            if (permissions.isRASPEnabled()) {
              var total =
                angular.isDefined(app.production_protected) &&
                angular.isNumber(app.production_protected.total)
                  ? app.production_protected.total
                  : 0
              var protect =
                angular.isDefined(app.production_protected) &&
                angular.isNumber(app.production_protected.protect)
                  ? app.production_protected.protect
                  : 0
              app.protectPercent =
                total === 0 ? 0 : Math.floor((100 * protect) / total)
            }

            if ($scope.model.selectAllCheckbox) {
              app.selected = true
              $scope.selectedApplications.push(app)
            }
          }

          $scope.applications = $scope.applications.concat(apps)

          if ($scope.count < minAppsForNormalFooter) {
            $rootScope.$broadcast('changeFooterBottom', {
              shouldSendToBottom: true
            })
          } else {
            $rootScope.$broadcast('changeFooterBottom', {
              shouldSendToBottom: false
            })
          }

          $timeout(function () {
            $scope.$emit('triggerScrollCheck')
          })

          $scope.model.busy = false
        })
        .catch(ServiceUtils.handleError)
    }

    function getScore(appId) {
      if (!$scope.applicationScores[appId] && !_scoreRequests[appId]) {
        _scoreRequests[appId] = ApplicationFactory.getScore(appId)
          .then(function (response) {
            $scope.applicationScores[appId] = response.data.scores
          })
          .catch(ServiceUtils.handleError)
      }
    }

    function getQuickFilters() {
      var filters = {
        includeArchived: $scope.model.includeArchived,
        filterText: $scope.model.searchKeywords()
      }

      angular.extend(
        filters,
        AdvancedFiltersService.transformSelectedSubfilters(
          _selectedSubFilters,
          _requestMapping
        )
      )

      return ApplicationService.getApplicationsQuickFilters(filters).then(
        function (filters) {
          $scope.quickFilters = filters

          $scope.selectedQuickFilter = $scope.quickFilters.find(function (
            filter
          ) {
            return filter.filterType == $scope.selectedQuickFilter.filterType
          })
        }
      )
    }

    function getApplicationShorts() {
      if (_lastShortSearch) {
        PromiseService.cancelPromise(_lastShortSearch)
      }

      _lastShortSearchLoading = true
      _shortApplications = []

      var filters = {
        includeArchived: $scope.model.includeArchived,
        filterText: $scope.model.searchKeywords(),
        quickFilter: $scope.selectedQuickFilter.filterType
      }

      angular.extend(
        filters,
        AdvancedFiltersService.transformSelectedSubfilters(
          _selectedSubFilters,
          _requestMapping
        )
      )

      _lastShortSearch =
        ApplicationService.getShortApplicationsByFilter(filters)

      return _lastShortSearch.then(function (response) {
        _lastShortSearchLoading = false
        _shortApplications = response.data.applications
      })
    }

    function getAllApplicationIds() {
      if (!_lastShortSearchLoading) {
        return $q.when(_shortApplications)
      }

      return _lastShortSearch.then(function () {
        return _shortApplications
      })
    }

    function quickFilterSelect(filter) {
      $scope.selectedQuickFilter = filter
      return ($scope.model.busyPromise = loadSubfilters().then(function () {
        return refreshApplications(false)
      }))
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      loadSubfilters().then(refreshApplications)

      return _searchKeywords
    }

    function getFiltersSelected(id) {
      if (id) {
        return AdvancedFiltersService.buildSelectedMessage(
          _selectedSubFilters[id]
        )
      }
      return ''
    }

    function toggleFilters() {
      $scope.filtersVisible = !$scope.filtersVisible
    }

    function filtersSet() {
      var i = 0

      for (; i < _subfilterIds.length; i++) {
        if (_selectedSubFilters[_subfilterIds[i]].length > 0) {
          return true
        }
      }
      return false
    }

    function clearFilters() {
      _clearSubFilters()
      $scope.model.includeArchived = false
      return ($scope.model.busyPromise =
        loadFilters().then(refreshApplications))
    }

    function _clearSubFilters() {
      var i = 0,
        len = _subfilterIds.length,
        subfilterId
      for (; i < len; i++) {
        subfilterId = _subfilterIds[i]
        _selectedSubFilters[subfilterId] = []
      }
    }

    function loadFilters() {
      return ApplicationService.getFiltersCatalogs().then(function (catalogs) {
        if (catalogs) {
          $scope.tagsfilters.filters = angular.copy(catalogs)
          _updateQuickFilters()
          return loadSubfilters().then(getQuickFilters)
        }
      })
    }

    function _hasLoadFilter() {
      return LoadFilterService.getApplicationsQuickFilter()
    }

    function _updateQuickFilters() {
      if (_hasLoadFilter()) {
        if (LoadFilterService.getApplicationsQuickFilter()) {
          var quickFilter = LoadFilterService.getApplicationsQuickFilter()
          $scope.selectedQuickFilter = {
            name: QUICK_FILTERS.APPS[quickFilter].VALUE,
            filterType: QUICK_FILTERS.APPS[quickFilter].KEY,
            count: '?'
          }
          LoadFilterService.setApplicationsQuickFilter(false)
        }
      }
    }

    function newSearch() {
      $scope.applications = []
      $scope.selectedApplications = []
      return loadApplications($scope.numPerLoad, 0)
    }

    function loadSubfilterOptions(subfilter) {
      if (!subfilter.opened && !subfilter.subfiltersLoaded) {
        return AdvancedFiltersService.loadSubfilters(
          [subfilter],
          _lastSubfilterSearches,
          {
            quickFilter: $scope.selectedQuickFilter.filterType,
            filterText: $scope.model.searchKeywords(),
            includeArchived: $scope.model.includeArchived
          },
          AdvancedFiltersService.transformSelectedSubfilters(
            _selectedSubFilters,
            _requestMapping
          ),
          getSubfilterRequest,
          checkSubfilterForServers
        )
      }
    }

    function loadSubfilters() {
      return AdvancedFiltersService.loadSubfilters(
        AdvancedFiltersService.buildSubfiltersToBeLoaded(
          $scope.tagsfilters.filters
        ),
        _lastSubfilterSearches,
        {
          quickFilter: $scope.selectedQuickFilter.filterType,
          filterText: $scope.model.searchKeywords(),
          includeArchived: $scope.model.includeArchived
        },
        AdvancedFiltersService.transformSelectedSubfilters(
          _selectedSubFilters,
          _requestMapping
        ),
        getSubfilterRequest,
        checkSubfilterForServers
      )
    }

    function getSubfilterRequest(filterId, searchFilters) {
      searchFilters.includeArchived = $scope.model.includeArchived
      return ApplicationService.getFiltersByType(filterId, searchFilters)
    }

    function checkSubfilterForServers(filter, subFilter) {
      var shouldSelect = false
      switch (filter.id) {
        case SUBFILTERS.APPS.ORG.ENUM.SERVERS:
          var servers = LoadFilterService.getServers()
          if (servers.length > 0) {
            for (var i = 0; i < servers.length; i++) {
              if (servers[i] === subFilter.keycode) {
                shouldSelect = true
                LoadFilterService.getServers().splice(i, 1)
                i--
              }
            }
          }
          break

        case SUBFILTERS.APPS.ORG.ENUM.LANGUAGES:
          if (
            LoadFilterService.getApplicationLanguage() === subFilter.keycode
          ) {
            LoadFilterService.setApplicationLanguage(false)
            shouldSelect = true
          }
          break

        default:
          break
      }

      if (shouldSelect) {
        subFilter.checked = true
        filter.opened = true
        $scope.selectSubfilter(subFilter, filter)
      }
    }

    function tagApplications(selectedApplications) {
      return ApplicationService.launchTagApplicationsModal(
        selectedApplications
      ).then(clearFilters)
    }

    function tagSelectedApplications() {
      if ($scope.model.selectAllCheckbox) {
        getAllApplicationIds().then(function (apps) {
          tagApplications(apps)
        })
      } else {
        tagApplications($scope.selectedApplications)
      }
    }

    function onArchivedChange() {
      _updateQuickFilters()
      return ($scope.model.busyPromise = getQuickFilters()
        .then(loadSubfilters)
        .then(function () {
          refreshApplications(false)
        }))
    }

    function onIncludeChildren() {
      return ($scope.model.busyPromise = refreshApplications(false))
    }

    function refreshApplications(reloadQuickFilters) {
      var promise
      if (angular.isUndefined(reloadQuickFilters) || reloadQuickFilters) {
        promise = getQuickFilters()
      }

      if ($scope.model.selectAllCheckbox) {
        if (promise) {
          promise = promise.then(getApplicationShorts)
        } else {
          promise = getApplicationShorts()
        }
      }

      if (promise) {
        return promise.then(newSearch)
      }

      return newSearch()
    }

    function hasAssessLicenses() {
      return $scope.licenses.unused > 0
    }

    function getLicenses() {
      return LicenseService.getAssessmentBreakdown().then(function (breakdown) {
        $scope.licenses = breakdown
      })
    }

    function loadApplicationsByScroll() {
      if ($scope.applications.length == $scope.count || $scope.model.busy) {
        return
      }

      return ($scope.model.scrollPromise = loadApplications(
        $scope.numPerLoad,
        $scope.applications.length
      ))
    }

    function setOrder(rowName) {
      if ($scope.order === rowName) {
        return
      }

      $scope.order = rowName

      return ($scope.model.busyPromise = refreshApplications(false))
    }

    function onSelectAll() {
      if ($scope.model.selectAllCheckbox) {
        selectAll()
      } else {
        deselectAll()
      }
    }

    function onSingleSelectAll() {
      $scope.deselectAll()
    }

    function selectAll() {
      getApplicationShorts()

      $scope.applications.forEach(function (app) {
        if (app.app_id != UserService.getSampleApplicationID()) {
          $scope.selectedApplications.push(app)
        }
      })

      for (var i = 0; i < $scope.applications.length; i++) {
        var app = $scope.applications[i]
        if (app.app_id != UserService.getSampleApplicationID()) {
          app.selected = true
        }
      }

      return $scope.selectedApplications
    }

    function deselectAll() {
      $scope.selectedApplications = []

      for (var i = 0; i < $scope.applications.length; i++) {
        var app = $scope.applications[i]
        app.selected = false
      }

      return $scope.selectedApplications
    }

    function toggleSelection(application) {
      var idx = $scope.selectedApplications.indexOf(application)

      if (idx > -1) {
        $scope.selectedApplications.splice(idx, 1)
      } else {
        $scope.selectedApplications.push(application)
      }
      if ($scope.selectedApplications.length != $scope.applications.length) {
        $scope.model.selectAllCheckbox = false
      }

      return $scope.selectedApplications
    }

    function canApplyLicense(app) {
      return (
        app.license.level !== APPLICATION_LICENSES.LICENSED &&
        $scope.licenses.unused > 0
      )
    }

    function launchBatchDialog(action) {
      if ($scope.model.selectAllCheckbox) {
        if (action == 'archive' || action == 'merge') {
          var filters = {
            offset: 0,
            limit: null,
            expand: '',
            sort: $scope.order,
            includeArchived: $scope.model.includeArchived,
            filterText: $scope.model.searchKeywords(),
            includeMerged: _includeMerged,
            quickFilter: $scope.selectedQuickFilter.filterType
          }

          angular.extend(
            filters,
            AdvancedFiltersService.transformSelectedSubfilters(
              _selectedSubFilters,
              _requestMapping
            )
          )
          return ApplicationService.getApplicationsByFilter(filters).then(
            function (data) {
              $scope.launchDialog(action, data.applications)
            }
          )
        }

        return getAllApplicationIds().then(function (apps) {
          $scope.launchDialog(action, apps)
        })
      } else {
        return $scope.launchDialog(action, $scope.selectedApplications)
      }
    }

    function launchSingleDialog(action, app) {
      return $scope.launchDialog(action, [app])
    }

    function _getBatchResults(results) {
      angular.forEach(results, function (result) {
        logger.logSuccess(result.data.messages[0])
      })
      return loadSubfilters()
        .then(refreshApplications)
        .catch(function () {
          var requireRefresh = false
          angular.forEach(results, function (result) {
            if (result.status === 200) {
              logger.logSuccess(result.data.messages[0])
              requireRefresh = true
            } else {
              ErrorService.processError(result)
            }
          })

          if (requireRefresh) {
            return loadSubfilters().then(refreshApplications)
          }
        })
    }

    function archiveApps(primaryApps, normalApps, reload) {
      if (primaryApps.length > 0) {
        ApplicationService.archivePrimaryApps(primaryApps)
          .then(function () {
            archiveApps(primaryApps, normalApps, true)
          })
          .catch(function () {
            archiveApps(primaryApps, normalApps, reload)
          })
      } else if (normalApps.length > 0) {
        ApplicationService.archiveNormalApps(normalApps)
          .then(function () {
            normalApps = []
            archiveApps(primaryApps, normalApps, true)
          })
          .catch(function () {
            normalApps = []
            archiveApps(primaryApps, normalApps, reload)
          })
      } else {
        if (reload) {
          return loadSubfilters().then(refreshApplications)
        }
      }
    }

    function launchDialog(action, apps) {
      var transl = {
        title_pleaseConfirmAction: $translate.instant(
          'title_pleaseConfirmAction'
        ),
        action_cancel: $translate.instant('action_cancel'),
        action_delete: $translate.instant('action_delete'),
        action_unarchiveApp: $translate.instant('action_unarchiveApp'),
        title_warning: $translate.instant('title_warning'),
        detail_applications_archivedAppsUnavailableToMerge: $translate.instant(
          'detail_applications_archivedAppsUnavailableToMerge'
        ),
        plural_applications_deleteApplicationsConfirmation: $translate.instant(
          'plural_applications_deleteApplicationsConfirmation',
          { count: apps.length },
          'messageformat'
        ),
        plural_applications_restoreApplicationsConfirmation: $translate.instant(
          'plural_applications_restoreApplicationsConfirmation',
          { count: apps.length },
          'messageformat'
        ),
        action_applications_reset_application: $translate.instant(
          'action_applications_reset_application'
        ),
        detail_applications_resetApplicationsConfirmation: $translate.instant(
          'detail_applications_resetApplicationsConfirmation'
        )
      }

      if (action === 'archive') {
        var primaryApps = $filter('filter')(apps, { primary: true })
        var normalApps = $filter('filter')(apps, { primary: false })
        archiveApps(primaryApps, normalApps, false)
      } else if (action === 'restore') {
        return confirmModal
          .open({
            title: transl.title_pleaseConfirmAction,
            message: transl.plural_applications_restoreApplicationsConfirmation,
            dialogOptions: {
              size: 'sm',
              yes: transl.action_unarchiveApp,
              no: transl.action_cancel
            }
          })
          .then(function (confirmed) {
            if (confirmed) {
              return ApplicationService.restoreBatch(apps).then(
                _getBatchResults
              )
            }
          })
      } else if (action === 'reset') {
        return confirmModal
          .open({
            title: transl.title_pleaseConfirmAction,
            message: transl.detail_applications_resetApplicationsConfirmation,
            dialogOptions: {
              size: 'sm',
              yes: transl.action_applications_reset_application,
              no: transl.action_cancel
            }
          })
          .then(function (confirmed) {
            if (confirmed) {
              return ApplicationService.resetBatch(apps).then(_getBatchResults)
            }
          })
      } else if (action === 'delete') {
        return confirmModal
          .open({
            title: transl.title_pleaseConfirmAction,
            message: transl.plural_applications_deleteApplicationsConfirmation,
            dialogOptions: {
              size: 'sm',
              yes: transl.action_delete,
              no: transl.action_cancel
            }
          })
          .then(function (confirmed) {
            if (confirmed) {
              return ApplicationService.deleteBatch(apps).then(_getBatchResults)
            }
          })
      } else if (action === 'group') {
        return ApplicationService.launchAppGroupModal(apps)
          .then(loadSubfilters)
          .then(refreshApplications)
      } else if (action === 'merge') {
        var archived = $filter('filter')(apps, { archived: true })

        if (archived.length > 0) {
          dialogs.notify(
            transl.title_warning,
            transl.detail_applications_archivedAppsUnavailableToMerge
          )
          return
        }

        return ApplicationService.launchAppMergeModal(apps)
          .then(loadFilters)
          .then(refreshApplications)
      } else if (action === 'license') {
        if (canApplyLicense(apps[0])) {
          return LicenseService.applyAssessLicense(apps[0], $scope.licenses)
            .then(loadSubfilters)
            .then(getLicenses)
            .then(function () {
              $rootScope.$broadcast('roles:updated')
            })
            .then(refreshApplications)
        } else {
          return LicenseService.noAvailableLicenses()
        }
      } else if (action === 'unmerge') {
        return ApplicationService.confirmUnmergeModal(apps[0])
          .then(loadSubfilters)
          .then(refreshApplications)
      }
    }

    function areAllArchived() {
      return checkArchivedStatus(true)
    }

    function areAllUnarchived() {
      return checkArchivedStatus(false)
    }

    function checkArchivedStatus(status) {
      var valid = true
      angular.forEach($scope.selectedApplications, function (app) {
        if (app.archived !== status) {
          valid = false
        }
      })

      return valid
    }

    function enableAction(requiredRole) {
      var valid = true
      angular.forEach($scope.selectedApplications, function (app) {
        if (!permissions.hasAppPermission(app.app_id, requiredRole)) {
          valid = false
        }
      })

      return valid
    }

    function updateImportanceLevel(data, app) {
      if (data != app.importance) {
        var form = { importance: data }
        ApplicationService.updateImportance(app.app_id, form).then(function () {
          if ($scope.order.indexOf('appImportance') >= 0) {
            return refreshApplications()
          }
        })
      }
    }

    function openPopover(app) {
      _.each($scope.applications, function (app) {
        app.popover = false
      })

      app.popover = true
    }

    function moveToCritical(app) {
      var filters = {}
      filters[SUBFILTERS.VULNS.ENUM.SEVERITY] = ['CRITICAL']

      LoadFilterRouteService.goToApplicationVulnerabilities(filters, app.app_id)
    }

    $scope.$watch('includeArchived', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        loadSubfilters()
      }
    })

    $scope.$on('application.reload', function () {
      refreshApplications()
    })

    function showChildModule() {
      return $scope.model.includeChildren
    }

    function onAppServersClick(application) {
      LoadFilterRouteService.goToServersFilteredByApp(
        application.app_id,
        SERVER_ENVIRONMENT.PRODUCTION.value
      )
    }

    function isAssessSupported(application) {
      return !isPythonApp(application) && !isProxy(application)
    }

    function isNodeApp(application) {
      return (
        angular.isDefined(application) &&
        LanguagesService.isNode(application.language)
      )
    }

    function isPythonApp(application) {
      return (
        angular.isDefined(application) &&
        LanguagesService.isPython(application.language)
      )
    }

    function isProxy(application) {
      return (
        angular.isDefined(application) &&
        LanguagesService.isProxy(application.language)
      )
    }

    function isSampleApplication(application) {
      return application.app_id === UserService.getSampleApplicationID()
    }

    init()
  }
})()
